import { zodStringNullable } from '@qapline/helpers';
import { z } from 'zod';

export const customerContactSchema = z.object({
    customerContact_id: z.number(),
    customer_id: z.number(),
    email: zodStringNullable(),
    name: zodStringNullable(),
    surname: zodStringNullable(),
    phone: zodStringNullable(),
    deleted: z.boolean(),
});

export type TCustomerContact = z.infer<typeof customerContactSchema>;
